package common

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 13.10.22
 * Author : marcusspors
 */
enum class EColors(val mHex: String) {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    RED("#E92120"),
    ORANGE_GRADIENT_PRE("#FFA800"),
    ORANGE("#FF6B00"),
    ORANGE_GRADIENT_POST("#E92120"),
    INACTIVE_ORANGE("#E7D1BF"),
    GRAY("#A2A6AF"),
    SECONDARY_BUTTON("#616469"),
    DECORATIVE_GRAY("#A2A6AF40"),
    DECORATIVE_GRAY_NON_TRANSPARENT("#e8e9eb"),
    DECORATIVE_BLACK("#00000026"),
    DECORATIVE_BACKGROUND("#FBF8F5"),
    TOUR_COLOR_1("#626452"),
    TOUR_COLOR_2("#C7C4BF"),
    TOUR_COLOR_3("#454443"),
    TOUR_COLOR_4("#A09744"),
    TOUR_COLOR_5("#809461"),

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}